import { createContext, DependencyList, ReactNode, useContext, useEffect } from 'react'

export let SidecarContext = createContext<{
  content: ReactNode
  setContent: (node: ReactNode) => void
} | null>(null)

export function useSidecar(renderContent: () => ReactNode, deps: DependencyList) {
  let context = useContext(SidecarContext)
  useEffect(() => {
    context?.setContent(renderContent())
    return () => context?.setContent(null)
  }, deps || [])
}
